import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import {
    formatNumber,
    getNumberParts
} from '../../service/FormatHelpers/FormatHelpers';

import './NumericValue.css';

export enum NumericValueType {
    PERCENTAGE = 'PERCENTAGE',
    PRICE = 'price'
}

export interface NumericValueProps {
    value: number | string | undefined | null;
    type?: NumericValueType;
    currencyCode?: string;
}
// marfuzzi@todo сделать отрисовку денег одинаковой с гридами
export class NumericValue extends React.Component<NumericValueProps, {}> {
    render() {
        const { type, value, currencyCode } = this.props;

        const numberValue = Number(value);

        switch (type) {
            case NumericValueType.PERCENTAGE:
                return (
                    <div
                        className={Bem.cls('numeric-value', '', {
                            type: NumericValueType.PERCENTAGE
                        })}
                        data-unit="%"
                    >
                        {formatNumber(numberValue, 2)}
                    </div>
                );

            case NumericValueType.PRICE:
                const { integerPart, fractionalPart } = getNumberParts(
                    numberValue,
                    2
                );

                return (
                    <div
                        className={Bem.cls('numeric-value', '', {
                            type: NumericValueType.PRICE
                        })}
                        data-unit={
                            currencyCode
                                ? mapStringToCurrencySymbol(currencyCode)
                                : undefined
                        }
                    >
                        {integerPart}
                        <span className={Bem.cls('numeric-value', 'coins')}>
                            ,{fractionalPart}
                        </span>
                    </div>
                );

            default:
                return (
                    <div className={Bem.cls('numeric-value')}>
                        {formatNumber(numberValue)}
                    </div>
                );
        }
    }
}
